module.exports = __webpack_public_path__ + "img/pVisa.f027339b.svg";